import { ServerResponse } from "../../types/baseType";
import { WeatherData } from "../../store/reducers/weather";
import { weatherURL } from "@utils/utils";
import xhr from '@infobis/api-module'

export default class WeatherService {
  
  static fetchWeatherByGeozoneIds = async (geoZoneIds: number[], from: number, to: number, thunkApi: any) => {
    const request = {
      url: weatherURL(`weatherAtWork?geoZoneIds=${geoZoneIds.join(',')}&from=${from}&to=${to}`),
      params: {
        method: 'GET',
      },
    };

    return xhr.fetch<ServerResponse<WeatherData[]>>(weatherURL(`weatherAtWork?geoZoneIds=${geoZoneIds.join(',')}&from=${from}&to=${to}`), {
        signal: thunkApi.signal
    })
  }

}
